<div class="modal-header">
	<button class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TR "Backup der Reglerkonfiguration"}}</h4>
</div>
<div class="modal-body">
	<div class="panel-group" id="accordion">
		<div class="panel panel-default">
			<div class="panel-heading">
				<h4 class="panel-title">
					<a id="js-panel-save" class="js-toggleMode" data-toggle="collapse" data-parent="#accordion" href="#collapse1" aria-expanded="true">{{TR 'Erstellen'}}</a>
				</h4>
			</div>
			<div id="collapse1" class="panel-collapse collapse in">
				<div class="row m-t-10 m-b-20">
					<div class="col-xs-12">
						{{TR 'Legt ein Backup der aktuellen Reglerkonfiguration an.'}}
						<input type="text" id="js-note" class="form-control m-t-15" name="note" placeholder="{{TR "Anmerkung zum Backup (optional)"}}" maxlength="100"/>
					</div>
				</div>
			</div>
		</div>
		<div class="panel panel-default">
			<div class="panel-heading">
				<h4 class="panel-title">
					<a id="js-panel-restore" class="js-toggleMode collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse2">{{TR "Einspielen"}}</a>
				</h4>
			</div>
			<div id="collapse2" class="panel-collapse collapse">
				<div class="row m-t-10 m-b-20">
					<div class="col-xs-12">
						<div class="alert alert-danger"><b>{{TR "Beim Einspielen einer Konfiguration wird die aktuelle Konfiguration überschrieben. Diese Aktion kann nicht rückgängig gemacht werden!"}}</b></div>
						<select id="df-backups" class="selectpicker" data-style="btn-white btn-sm" data-live-search="true">
							<option class="hidden" value="">{{TR "Konfiguration auswählen"}}</option>
							<optgroup label="{{TR "Dieses Gerät"}}">
							{{#each ownBackups}}
							<option value="{{id}}">{{TIME date}}{{#if note}}, {{note}}{{/if}}{{#if auto}}, {{TR 'automatisches Backup'}}{{/if}}</option>
							{{/each}}
							</optgroup>
							<optgroup label="{{TR "Andere Geräte"}}">
							{{#each otherBackups}}
							<option value="{{id}}">{{device}}, {{TIME date}}{{#if note}}, {{note}}{{/if}}{{#if auto}}, {{TR 'automatisches Backup'}}{{/if}}</option>
							{{/each}}
							</optgroup>
						</select>
					</div>
				</div>
			</div>
		</div>
		<div class="panel panel-default">
			<div class="panel-heading">
				<h4 class="panel-title">
					<a id="js-panel-download" class="js-toggleMode collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapse3">{{TR "Herunterladen"}}</a>
				</h4>
			</div>
			<div id="collapse3" class="panel-collapse collapse">
				<div class="row m-t-10 m-b-20">
					<div class="col-xs-12">
						{{TR 'Wählen Sie ein oder mehrere Backups zum Download als TROVIS VIEW Datei.'}}
						<select id="df-downloads" class="selectpicker js-filter-multiselect m-t-15" multiple="multiple" data-style="btn-white btn-sm" name="df_labels" data-live-search="true" >
						{{#each ownBackups}}
						<option value="{{id}}">{{TIME date}}{{#if note}}, {{note}}{{/if}}</option>
						{{/each}}
						</select>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button id="ct-cancel" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-apply">{{TR "Ausführen"}}</button>
</div>
